import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useChildCreation');

    return {
        ADD_BOUNDARY: t('addBoundary'),
        ADD_FARM: t('addFarm'),
        ADD_FIELD: t('addField')
    };
};

export default useTranslation;
